export default __webpack_public_path__ + "28a0197e85a0530ca4bb801eaad5cff4.png";